
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { navItems } from "./navigation/navTypes";
import MobileNavSelector from "./navigation/MobileNavSelector";
import NavItem from "./navigation/NavItem";
import CollapsibleNavItem from "./navigation/CollapsibleNavItem";

const CustomerPortalNav = () => {
  const location = useLocation();
  const [expandedItems, setExpandedItems] = useState<string[]>([]);
  
  const toggleExpanded = (title: string) => {
    setExpandedItems(prev => 
      prev.includes(title) 
        ? prev.filter(item => item !== title)
        : [...prev, title]
    );
  };
  
  // Check if the current location is within a section's subitems
  const isActiveSection = (item: typeof navItems[0]) => {
    if (location.pathname === item.href) return true;
    return item.subItems?.some(subItem => location.pathname === subItem.href) || false;
  };

  return (
    <div className="bg-card border rounded-lg p-4 md:p-0">
      <MobileNavSelector />
      
      <nav className="hidden md:block space-y-1">
        {navItems.map((item) => {
          const hasSubItems = item.subItems && item.subItems.length > 0;
          const isActive = isActiveSection(item);
          const isExpanded = expandedItems.includes(item.title) || isActive;
          
          return (
            <div key={item.title} className="space-y-1">
              {hasSubItems ? (
                <CollapsibleNavItem 
                  item={item}
                  isExpanded={isExpanded}
                  toggleExpanded={toggleExpanded}
                />
              ) : (
                <NavItem item={item} />
              )}
            </div>
          );
        })}
      </nav>
    </div>
  );
};

export default CustomerPortalNav;
